/*
  Pythal article page: fills the "In this story" index from the story's headings with a scroll spy,
  drives the reading-progress line and copies the article link.
*/
(() => {
  const root = document.querySelector('.py-ar');
  if (!root) return;
  const body = root.querySelector('[data-py-ar-body]');

  // 1. Story index from h2/h3 headings.
  const toc = root.querySelector('[data-py-ar-toc]');
  const list = root.querySelector('[data-py-ar-toc-list]');
  const headings = body ? [...body.querySelectorAll('h2, h3')].filter((h) => h.textContent.trim()) : [];
  const links = [];
  if (toc && list && headings.length >= 2) {
    headings.forEach((h, i) => {
      if (!h.id) h.id = 'py-ar-' + (i + 1);
      const a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      const li = document.createElement('li');
      li.appendChild(a);
      list.appendChild(li);
      links.push(a);
    });
    toc.hidden = false;

    const spy = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const i = headings.indexOf(entry.target);
        links.forEach((a, j) => a.classList.toggle('is-active', j === i));
      });
    }, { rootMargin: '-15% 0px -70% 0px' });
    headings.forEach((h) => spy.observe(h));
  }

  // 2. Reading progress across the story column.
  const bar = root.querySelector('[data-py-ar-progress]');
  if (bar && body) {
    let ticking = false;
    const update = () => {
      ticking = false;
      const rect = body.getBoundingClientRect();
      const total = rect.height - window.innerHeight * 0.6;
      const done = Math.min(1, Math.max(0, (window.innerHeight * 0.4 - rect.top) / Math.max(total, 1)));
      bar.style.setProperty('--py-ar-progress', done.toFixed(4));
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  // 3. Copy link.
  const copy = root.querySelector('[data-py-ar-copy]');
  const status = root.querySelector('[data-py-ar-copied]');
  if (copy) {
    copy.addEventListener('click', async () => {
      const url = copy.getAttribute('data-py-ar-copy');
      try {
        await navigator.clipboard.writeText(url);
        if (status) status.textContent = copy.getAttribute('data-py-ar-copied-label') || 'Link copied';
      } catch (e) {
        if (status) status.textContent = url;
      }
      setTimeout(() => { if (status) status.textContent = ''; }, 2400);
    });
  }
})();
